import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { DirektvermarktungContractOverviewResponse } from "../Direktvermarktung.types";

interface DirektvermarktungContractsQueryParams {
  variantId?: string | null;
  contractId?: string | null;
  activeOnly?: boolean | null;
  expiredOnly?: boolean | null;
  upcomingOnly?: boolean | null;
}

export const direktvermarktungContractsQueries = {
  all: () =>
    queryOptions<Array<DirektvermarktungContractOverviewResponse>>({
      queryKey: ["direktvermarktungContracts"]
    }),
  list: ({
    variantId,
    contractId,
    activeOnly,
    expiredOnly,
    upcomingOnly
  }: DirektvermarktungContractsQueryParams = {}) =>
    queryOptions<Array<DirektvermarktungContractOverviewResponse>>({
      queryKey: [
        ...direktvermarktungContractsQueries.all().queryKey,
        { variantId, contractId, activeOnly, expiredOnly, upcomingOnly }
      ],
      queryFn: () =>
        fetchDirektvermarktungContracts(
          variantId,
          contractId,
          activeOnly,
          expiredOnly,
          upcomingOnly
        )
    })
};

interface UseDirektvermarktungContractsOptions extends DirektvermarktungContractsQueryParams {
  options?: Partial<
    UseQueryOptions<Array<DirektvermarktungContractOverviewResponse>>
  >;
}

export function useDirektvermarktungContracts({
  variantId,
  contractId,
  activeOnly,
  expiredOnly,
  upcomingOnly,
  options
}: UseDirektvermarktungContractsOptions) {
  return useQuery({
    ...direktvermarktungContractsQueries.list({
      variantId,
      contractId,
      activeOnly,
      expiredOnly,
      upcomingOnly
    }),
    ...options
  });
}

async function fetchDirektvermarktungContracts(
  variantId?: string | null,
  contractId?: string | null,
  activeOnly?: boolean | null,
  expiredOnly?: boolean | null,
  upcomingOnly?: boolean | null
) {
  const direktvermarktungContractsUrl =
    urls.apiWithoutCamelization.direktvermarktungContracts({
      variantId: variantId ?? undefined,
      contractId: contractId ?? undefined,
      activeOnly: activeOnly ?? undefined,
      expiredOnly: expiredOnly ?? undefined,
      upcomingOnly: upcomingOnly ?? undefined
    });
  const response = await apiWithoutCamelization.get<
    Array<DirektvermarktungContractOverviewResponse>
  >(direktvermarktungContractsUrl);
  return response.data;
}
